import { FeatureFlag } from '../FeatureFlag';

export const enableLab2AutoAccept = new FeatureFlag({
    key: 'enable-lab-2-auto-accept',
    defaultValue: false,
});
